<template>
  <li class="activity-item">
    <small-box-story :story="story" :from="'recent-activity'"></small-box-story>
  </li>
</template>

<script>
  import SmallBoxStory from '../news/sections/SmallBoxStory.vue'

  export default {
    components: {
      SmallBoxStory
    },
    props: {
      story: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped>
  li {
    list-style: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/recent-activity/RecentActivityListItem.vue